import axios from "axios";
import { globalAction } from "redux-subspace";
import { decrypt, getClaims } from "../../../modules/login";
import { REFRESH_DATA_COMMENTS } from "../CommentTable/CommentTable.store";

const getParticipantName = (state) => {
  const loggedInUsername = decrypt(state?.loginReducer.name);
  const username = state?.smartPageHeaderReducer?.participantUgnxId;

  return loggedInUsername === username ? null : username;
};

// Constants
const SET_AUDIT_TRAIL_SCREENSHOT = "SET_AUDIT_TRAIL_SCREENSHOT";
const AUDIT_TRAIL_COMMENT_RESET_STATE = "AUDIT_TRAIL_COMMENT_RESET_STATE";
const SET_AUDIT_TRAIL_COMMENT_MODAL_SHOW = "SET_AUDIT_TRAIL_COMMENT_MODAL_SHOW";
const SET_AUDIT_TRAIL_COMMENT_SUBMIT_ERROR =
  "SET_AUDIT_TRAIL_COMMENT_SUBMIT_ERROR";

const LOGOUT = "LOGOUT";

// Acessors
const getScreenshot = (state) => state?.screenshot;
const getCommentModalShow = (state) => state?.commentModalShow;
const getSubmissionError = (state) => state?.submissionError;

const canCreateAuditTrailComment = (state) =>
  getClaims(state, "site.dataComment.canCreate");

const getUserName = (state) => getParticipantName(state);

// Default state
const initialState = {
  screenshot: null,
  commentModalShow: false,
  submissionError: false,
};

export const auditTrailCommentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUDIT_TRAIL_SCREENSHOT:
      const { screenshot } = action;
      return {
        ...state,
        screenshot: screenshot,
      };
    case SET_AUDIT_TRAIL_COMMENT_MODAL_SHOW:
      const { commentModalShow } = action;
      return {
        ...state,
        commentModalShow: commentModalShow,
      };
    case SET_AUDIT_TRAIL_COMMENT_SUBMIT_ERROR:
      const { submissionError } = action;
      return {
        ...state,
        submissionError: submissionError,
      };
    case AUDIT_TRAIL_COMMENT_RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

//Mutators

export const resetStates = () => (dispatch) => {
  return dispatch({
    type: AUDIT_TRAIL_COMMENT_RESET_STATE,
  });
};

export const setScreenshot = (screenshot) => (dispatch) => {
  return dispatch({
    type: SET_AUDIT_TRAIL_SCREENSHOT,
    screenshot: screenshot,
  });
};

export const setCommentModalShow = (commentModalShow) => (dispatch) => {
  return dispatch({
    type: SET_AUDIT_TRAIL_COMMENT_MODAL_SHOW,
    commentModalShow: commentModalShow,
  });
};

export const setSubmissionError = (submissionError) => (dispatch) => {
  return dispatch({
    type: SET_AUDIT_TRAIL_COMMENT_SUBMIT_ERROR,
    submissionError: submissionError,
  });
};

const saveAuditTrailComment = (formData) => async (dispatch, getState) => {
  return axios
    .post(`/api/audittrail/comment`, formData, {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
      },
    })
    .then(() => {
      dispatch(globalAction({ type: REFRESH_DATA_COMMENTS }));
      return Promise.resolve("Comment added successfully!");
    })
    .catch((e) => {
      return Promise.reject(
        e.response?.data
          ? e.response.data
          : "There was an error while trying to add the comment!"
      );
    });
};

export const mapStateToProps = (state) => {
  return {
    screenshot: getScreenshot(state),
    commentModalShow: getCommentModalShow(state),
    submissionError: getSubmissionError(state),
    canCreateAuditTrailComment: canCreateAuditTrailComment(state),
    username: getUserName(state),
  };
};

export const mapDispatchToProps = {
  setScreenshot,
  setCommentModalShow,
  setSubmissionError,
  saveAuditTrailComment,
};
